<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="newstxtbox">
      <div class="content">
        <div class="gy_nr">
          <div class="gy_wz" v-html="casesInfo.content"></div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import axios from 'axios';
  var CONFIG = require('@/common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;

  export default {
    data () {
      return {
        base_url: base_url,//base_url
        id: 0,//案例id
        casesInfo: [],//案例信息
      }
    },
    created: function () {
      var that = this;

      //获取案例详情
      that.getCasesInfo();

    },
    watch:{
      $route:function () {
        var that = this;
        //获取案例详情
        that.getCasesInfo();
      }
    },
    methods: {
      //获取案例详情
      getCasesInfo:function(){
        var that = this;
        //页面携带参数
        var id = that.$route.query.id;
        that.id = id;
        axios.post(base_url+'front/getInfoDetail', {'id': id}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataInfo = res.data.result;
            that.casesInfo = dataInfo;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

    }
  }
</script>

<style>
  @import url("./casesDetail.css");
</style>



// WEBPACK FOOTER //
// src/views/casesDetail/casesDetail.vue